export default {
  options: {
    true: 'Tak',
    false: 'Nie',
  },
};
